/**
 * @author        matt@zumper.com (Matthieu Devlin)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   pin click event thunk
 */

import { selectFilters } from '@zcode-ui/filters'
import { getUser } from '@zcode-ui/web-zumper-global-state'
import { PIN_CLICK, event, getTraktorEntityId } from '@zcode-ui/web-zumper-integrations'
import * as Optimizely from '@zcode/nr/es/shared/packages/optimizely-middleware'
import { PIN_CLICK as OPTLY_PIN_CLICK } from '@zcode/nr/es/shared/thirdParty/optimizely/constants'
import type { ExtraThunkArg } from '@zcode/state-type'

import { getCurrentLocation, selectSelectedPOICategory } from '../../../inspectors'
import type { Dispatch, GetState } from '../../types'

interface Props {
  buildingId?: number | null
  count?: number
  lat?: number
  listingId?: number | null
  listingIds?: readonly number[]
  lng?: number
  markerType: string
  pbId?: number | null
  plId?: number | null
}

export const trackPinClickEvent =
  ({ buildingId, count, lat, listingId, listingIds, lng, markerType, pbId, plId }: Props) =>
  (dispatch: Dispatch, getState: GetState, { optimizely }: ExtraThunkArg) => {
    const state = getState()
    const user = getUser(state)
    const filters = selectFilters(state)
    const location = getCurrentLocation(state)

    const props = {
      propertyId:
        (listingId || buildingId) &&
        getTraktorEntityId({
          buildingId,
          listingId: listingId ?? undefined,
          pbId,
          plId,
        }),
      pinStatus: 'normal',
      pinType: markerType,
      lat,
      lng,
      clusterCount: count,
      clusterPropertyIds: listingIds?.map((id) => `l-${id}`),
    }

    dispatch(Optimizely.track({ eventKey: OPTLY_PIN_CLICK }))

    dispatch(event({ name: PIN_CLICK, props, user, filters, location }))

    const poiCategory = selectSelectedPOICategory(state)

    optimizely?.track(PIN_CLICK, undefined, {
      category: poiCategory,
    })
  }
